import { notification } from 'antd';
import { ReactNode } from 'react';

// It follow the builder design pattern

type NotificationType = 'success' | 'info' | 'warning' | 'error';

class NotificationBuilder {
      private type: NotificationType = 'info';
      private messageContent: ReactNode = '';
      private descriptionContent: ReactNode = '';

      static success() {
            const builder = new NotificationBuilder();
            builder.type = 'success';
            return builder;
      }

      static info() {
            const builder = new NotificationBuilder();
            builder.type = 'info';
            return builder;
      }

      static warning() {
            const builder = new NotificationBuilder();
            builder.type = 'warning';
            return builder;
      }

      static error() {
            const builder = new NotificationBuilder();
            builder.type = 'error';
            return builder;
      }

      message(content: ReactNode) {
            this.messageContent = content;
            return this;
      }

      description(content: ReactNode) {
            this.descriptionContent = content;
            return this;
      }

      show() {
            notification[this.type]({
                  message: this.messageContent,
                  description: this.descriptionContent,
            });
      }
}

export const openNotification = {
      success: NotificationBuilder.success,
      info: NotificationBuilder.info,
      warning: NotificationBuilder.warning,
      error: NotificationBuilder.error,
};
